import { useStoreState } from "easy-peasy";
import { isEmpty } from "lodash";
import { Button, Modal } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";

export default function RequisitionApproveFooter({
  requisition, // The requisition data
  canPerformAction, //
  canReservedUserSend,
  reciever,
  approveAndClose,
  canReservedUserPerformAction,
  reject,
  preSelectedSignatoryData,
  approveOnly,
  id,
  canApproveAndClose,
  location,
  saveFormChanges,
}) {
  const navigate = useNavigate();
  const generalSettings = useStoreState((state) => state.generalSettings);

  // const approveAndSendLink = () => {
  //   navigate(`/requisition/request/approve-and-send/${id}`, {
  //     state: { backgroundLocation: location },
  //   });
  // };

  if (requisition?.requisitiontracks) {
    // closed in trail means no further action
    const isClosed = requisition?.requisitiontracks.find((el) => el.closedHere);
    if (isClosed) return null;
  }

  return (
    <>
      {canPerformAction(requisition) &&
        (requisition.filledFormData || !isEmpty(preSelectedSignatoryData) ? (
          <Modal.Footer className="d-print-none variant-2 gap-3">
            <Button
              onClick={() => reject()}
              variant="danger"
              className="text-white px-3 reject"
            >
              Reject
            </Button>

            <div className="proceed-actions">
              {reciever ? (
                <>
                  <Link
                    to={`/requisition/request/approve-and-send/${id}`}
                    state={{ backgroundLocation: location }}
                    className="btn btn-white border bg-white"
                  >
                    Approve & Send
                  </Link>
                </>
              ) : (
                <Button
                  className=""
                  onClick={() => approveAndClose()}
                  variant="primary"
                >
                  Approve & Close
                </Button>
              )}
            </div>
          </Modal.Footer>
        ) : (
          <Modal.Footer className="d-print-none variant-2">
            <Button
              onClick={() => reject()}
              variant="danger"
              className="text-white px-3 reject"
            >
              Reject
            </Button>

            <div className="proceed-actions">
              {!canApproveAndClose(requisition) && (
                <Link
                  to={`/requisition/request/approve-and-send/${id}`}
                  state={{ backgroundLocation: location }}
                  className="btn btn-white border bg-white"
                >
                  Approve & Send
                </Link>
              )}

              {canApproveAndClose(requisition) && (
                <>
                  {/* Can final still send  */}
                  {generalSettings?.finalSignatoryCanApproveAndSend && (
                    <Link
                      to={`/requisition/request/approve-and-send/${id}`}
                      state={{ backgroundLocation: location }}
                      className="btn btn-white border bg-white"
                    >
                      Approve & Send
                    </Link>
                  )}
                  <Button
                    className="approve-and-close"
                    onClick={() => approveAndClose()}
                    variant="primary"
                  >
                    Approve & Close
                  </Button>
                </>
              )}
            </div>
          </Modal.Footer>
        ))}

      {/* LOGIC -> user cannot perform action, but if a reserved user allow  */}
      {!canPerformAction(requisition) &&
      (canReservedUserPerformAction || canReservedUserSend) ? (
        <Modal.Footer className="d-print-none variant-2">
          <Button
            title="Reject"
            onClick={() =>
              reject({
                isReservedUser: true,
              })
            }
            variant="danger"
            className="text-white px-3 reject"
          >
            Reject
          </Button>

          <div className="proceed-actions">
            {canReservedUserSend && (
              <>
                <Button
                  className="btn btn-light-blue border"
                  onClick={() => approveOnly()}
                >
                  Approve
                </Button>

                <Link
                  to={`/requisition/request/approve-and-send/${id}`}
                  state={{ backgroundLocation: location }}
                  className="btn btn-white border bg-white"
                >
                  Approve & Send
                </Link>
              </>
            )}

            {canReservedUserPerformAction ? (
              <>
                {/* Can final still send  */}
                {generalSettings?.finalSignatoryCanApproveAndSend &&
                !canReservedUserSend ? (
                  <Link
                    to={`/requisition/request/approve-and-send/${id}`}
                    state={{ backgroundLocation: location }}
                    className="btn btn-white border bg-white"
                  >
                    Approve & Send
                  </Link>
                ) : null}

                <Button
                  className="approve-and-close"
                  onClick={() =>
                    approveAndClose({
                      isReservedUser: true,
                    })
                  }
                  variant="primary"
                >
                  Approve & Close
                </Button>
              </>
            ) : null}
          </div>
        </Modal.Footer>
      ) : null}
    </>
  );
}
